package com.solevo.dist.application.models

import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

// TODO UI model work

enum class QuoteStatus {
    Awaiting,
    Received,
    Error,
    Other
}

data class Quote(
    val quoteId: String = "",
    val totalAmount: Double? = null,
    val status: QuoteStatus = QuoteStatus.Awaiting,
    val createdAt: Instant = Clock.System.now(),
    val quoteLines: List<QuoteLine>? = null,
    val unread: Boolean = false,
    val legalEntityId: String = "",
    val customerId: String = "",
    val createdBy: String? = null,
    val acceptedBy: String? = null,
    val pickupDateFrom: Instant? = Clock.System.now(),
    val pickupDateTo: Instant? = Clock.System.now(),
    val quoteExpirationDate: Instant? = Clock.System.now(),
    val pickupToday: Boolean = true,
    val orderReference: String? = "",
    val subTotal: Double = 0.0,
    val tax: Double = 0.0,
    var appQuote: Boolean? = null,
    var errorCode: String? = null,
    var errorText: String? = null,
    var updatedBy: String? = null
)

@Serializable
data class QuoteLine(
    val productId: String = "",
    val lineNumber: Double = 0.0,
    val id: String? = "",
    val orderLineId: String? = "",
    val warehouseId: String = "",
    val quantity: Double = 0.0,
    var price: Int? = null,
    val unit: String = "",
    val totalPrice: Double = 0.0,
    val pricePerUnit: Double = 0.0,
)